//#region IMPORTS
import { PhotoIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { useTranslation } from "react-i18next";
//#endregion

//#region INTERFACE
interface Props {
  title: string;
  // WoodWing preview link (the large variant of the thumbnail).
  src?: string;
  onClose: () => void;
}
//#endregion

// Body of the preview modal on the week-order page. MainModal unmounts it when
// closed, so the error state starts fresh on every opening.
export default function WeekOrderImagePreview({ title, src, onClose }: Props) {
  //#region SETUP
  const { t } = useTranslation();
  const [failed, setFailed] = useState(false);
  //#endregion

  //#region RENDER
  return (
    <div>
      <div className="flex items-start justify-between gap-4">
        <h3 className="text-lg font-semibold text-gray-900 break-words">
          {title}
        </h3>
        <button
          type="button"
          onClick={onClose}
          className="shrink-0 rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
        >
          <span className="sr-only">{t("rituals.close", "Close")}</span>
          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>

      <div className="mt-4 flex min-h-[16rem] items-center justify-center rounded-md bg-gray-50">
        {src && !failed ? (
          <img
            src={src}
            alt={title}
            onError={() => setFailed(true)}
            className="max-h-[70vh] max-w-full object-contain"
          />
        ) : (
          <div className="flex flex-col items-center gap-2 text-gray-400">
            <PhotoIcon className="h-12 w-12" aria-hidden="true" />
            <p className="text-sm">{t("rituals.noImageAvailable")}</p>
          </div>
        )}
      </div>
    </div>
  );
  //#endregion
}
